import React, { useEffect, useRef } from 'react';

function ThirdPartyExtensions() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const esiNode = document.getElementById('esi-third-party-extensions');
    const container = ref.current;
    if (!esiNode || !container) return undefined;

    // Constrain width BEFORE moving the node — the flix MutationObserver on
    // <body> fires synchronously after appendChild and measures
    // parentNode.offsetWidth. Without this, it falls back to screen.width
    // and renders the carousel too wide. Using max-width (not width) so the
    // element still reflows naturally on browser resize.
    esiNode.style.maxWidth = `${container.clientWidth}px`;
    container.appendChild(esiNode);
    esiNode.hidden = false;

    return undefined;
  }, []);

  return <div ref={ref} />;
}

export default ThirdPartyExtensions;
